import * as Sentry from "@sentry/react";
import { ENVIRONMENT, SENTRY_DSN } from "./clientConfig";
import { PROJECT_ENVIRONMENT } from "./constants";

if (
  ENVIRONMENT === PROJECT_ENVIRONMENT.ENV_STAGE ||
  ENVIRONMENT === PROJECT_ENVIRONMENT.ENV_PRODUCTION
) {
  Sentry.init({
    dsn: SENTRY_DSN, // Replace with your actual DSN from Sentry
    debug: true, //<= useful if you run into any issues needing more info
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracePropagationTargets: ["localhost", /^https:\/\/savitarrealty\.com\//],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: ENVIRONMENT,
  });
}
